export function newsletter() {
  const forms = document.querySelectorAll('form[data-newsletter-form]');
  forms.forEach(form => {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      setTimeout(() => {
        if (form.classList.contains('success')) {
          form.classList.remove('success');
          const email = form.querySelector('[data-members-email]');
          if (email) {
            email.value = '';
          }
        }
        if (form.classList.contains('error')) {
          form.classList.remove('error');
        }
      }, 8000);
    });
  });
}
